import { render, staticRenderFns } from "./QQText.vue?vue&type=template&id=4da33952&scoped=true&"
import script from "./QQText.vue?vue&type=script&lang=ts&"
export * from "./QQText.vue?vue&type=script&lang=ts&"
import style0 from "./QQText.vue?vue&type=style&index=0&id=4da33952&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da33952",
  null
  
)

export default component.exports